<template>
  <div class="fields-block">
    <h2>{{ $t('payment.vehicle.car_details') }}</h2>
    <div v-for="(vehicle, key) in vehicles" :key="key">
      <h2 v-if="vehicles.length > 1" class="border-0 mb-1">
        {{ $t('payment.vehicle.car')}} {{ key + 1 }} {{ $t('payment.vehicle.details') }}
      </h2>
      <div class="row mt-2" v-if="existingVehicles && existingVehicles.length > 0">
        <div class="col-md-6 field-col">
          <div class="form-group">
            <strong class="label-holder">
              <label for="existingVehicle">{{ $t('payment.vehicle.existing_vehicles') }}</label>
            </strong>
            <span class="fake-select">
              <select id="existingVehicle" v-model="vehicle.existing" @change="applyExisting(key)">
                <option :selected="vehicle.existing ==  null" :value="null">
                  {{ $t('payment.vehicle.existing_vehicle') }}
                </option>
                <option v-for="(option, key) in existingVehicles" :key="key" :value="option.registration">
                  {{ option.registration }}
                </option>
              </select>
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 field-col">
          <input-reg
            v-model="vehicle.vehicle_reg"
            id="reg"
            type="text"
            label="payment.vehicle.registration"
            :index="key"
            @input="save(key)"
            :invalid="value.vehicles.$each[key].vehicle_reg.$error"
            @change="value.vehicles.$each[key].vehicle_reg.$touch()"
          />
          <span v-if="vehicle.response == 'error'" class="error">{{ $t('payment.vehicle.error') }}</span>
          <span class="error">{{ validationMsg(value.vehicles.$each[key].vehicle_reg) }}</span>
        </div>
        <div class="col-md-6 field-col">
          <input-select
            v-model="vehicle.no_passengers"
            id="return"
            :options="passengerOptions"
            optionType="Array"
            label="payment.vehicle.number_passengers"
            @input="save(key)"
          />
        </div>
        <div class="col-md-3 col-6 field-col">
          <input-base
            v-model="vehicle.vehicle_make"
            id="make"
            type="text"
            label="payment.vehicle.make"
            :invalid="value.vehicles.$each[key].vehicle_make.$error"
            @input="save(key)"
            @change="value.vehicles.$each[key].vehicle_make.$touch()"
          />
          <span class="error">{{ validationMsg(value.vehicles.$each[key].vehicle_make) }}</span>
        </div>
        <div class="col-md-3 col-6 field-col">
          <input-base
            v-model="vehicle.vehicle_model"
            id="model"
            type="text"
            label="payment.vehicle.model"
            :invalid="value.vehicles.$each[key].vehicle_model.$error"
            @input="save(key)"
            @change="value.vehicles.$each[key].vehicle_model.$touch()"
          />
          <span class="error">{{ validationMsg(value.vehicles.$each[key].vehicle_model) }}</span>
        </div>
        <div class="col-md-6 field-col">
          <input-base
            v-model="vehicle.vehicle_colour"
            id="color"
            type="text"
            label="payment.vehicle.color"
            :invalid="value.vehicles.$each[key].vehicle_colour.$error"
            @input="save(key)"
            @change="value.vehicles.$each[key].vehicle_model.$touch()"
          />
          <span class="error">{{ validationMsg(value.vehicles.$each[key].vehicle_colour) }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-12 field-col" v-if="multiCar">
          <button
            type="button"
            class="btn btn-secondary add mr-3"
            v-if="key + 1 == vehicles.length && vehicles.length < 4"
            @click="carAction(true)"
          >{{ $t('payment.vehicle.add') }}</button>
          <button
            type="button"
            class="btn btn-secondary remove"
            v-if="key > 0"
            :disabled="key < 1"
            @click="carAction(false, key)"
          >{{ $t('payment.vehicle.remove') }}</button>
        </div>
      </div>
      <hr v-if="key + 1 !== vehicles.length" />
    </div>
  </div>
</template>

<script>
import { sync, call, get } from "vuex-pathify";
import * as _ from "lodash";
import mixins from "@/mixins";
import { InputBase, InputReg, InputSelect } from "@/components";

export default {
  name: "vehicles",
  mixins: [mixins.load, mixins.validate],
  props: ["value"],
  components: { InputBase, InputSelect, InputReg },
  data() {
    return {
      passengerOptions: 7,
      existingVehicle: null
    }
  },
  computed: {
    vehicles: sync("payment/vehicles"),
    multiCar: get("payment/multiCar"),
    existingVehicles: get("customer/vehicles"),
  },
  methods: {
    addEmptyVehicle: call("payment/addEmptyVehicle"),
    updateVehicle: call('payment/updateVehicle'),
    removeVehicle: call("payment/removeVehicle"),
    totalCart: call('cart/totalCart'),
    carAction(action = true, index) {
      this.fakeLoad();
      action ? this.addEmptyVehicle() : this.removeVehicle(index);
      this.totalCart();
    },
    save(index) {
      this.updateVehicle({ index, vehicle: this.vehicles[index] })
    }, 
    applyExisting(index = 0, initial = false) {

      if(initial) {
        return this.updateVehicle({ 
          index: 0, 
          vehicle: { 
            ...this.vehicles[index],  vehicle_reg: this.existingVehicles[0].registration, vehicle_colour: this.existingVehicles[0].colour, vehicle_model: this.existingVehicles[0].model, vehicle_make: this.existingVehicles[0].make,
          }
        }) 
      } else if(this.vehicles[index].existing === null) {
        return this.updateVehicle({ 
          index, 
          vehicle: { 
            ...this.vehicles[index],  vehicle_reg: '', vehicle_colour: '', vehicle_model: '', vehicle_make: '',
          }
        })
      }

      let reg = initial ? this.existingVehicles[0].registration : this.vehicles[index].existing;
      let selected = _.cloneDeep(this.existingVehicles).find(vehicle => vehicle.registration == reg);

      this.updateVehicle({ 
        index, 
        vehicle: { 
          ...this.vehicles[index],  vehicle_reg: selected.registration, vehicle_colour: selected.colour, vehicle_model: selected.model, vehicle_make: selected.make,
        }
      })
    }
  },
  mounted() {
    if (this.vehicles.length < 1) this.addEmptyVehicle();
  }
};
</script>